import { render, staticRenderFns } from "./VirHomePart6.vue?vue&type=template&id=6a6c3f25&scoped=true&"
import script from "./VirHomePart6.vue?vue&type=script&lang=js&"
export * from "./VirHomePart6.vue?vue&type=script&lang=js&"
import style0 from "./VirHomePart6.vue?vue&type=style&index=0&id=6a6c3f25&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c3f25",
  null
  
)

export default component.exports